import { render } from "./SingleBundle.vue?vue&type=template&id=214e11a3&scoped=true"
import script from "./SingleBundle.vue?vue&type=script&lang=js"
export * from "./SingleBundle.vue?vue&type=script&lang=js"

import "./SingleBundle.vue?vue&type=style&index=0&id=214e11a3&lang=scss&scoped=true"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214e11a3"]])

export default __exports__